export const SET_SELECTED_SELF_RENEW = 'SET_SELECTED_SELF_RENEW';
export const REMOVE_SELECTED_SELF_RENEW = 'REMOVE_SELECTED_SELF_RENEW';
export const SET_FILTERS_MODAL = 'SET_FILTERS_MODAL';
export const SET_SELECTED_SCHEDULE = 'SET_SELECTED_SCHEDULE';
export const REMOVE_SELECTED_SCHEDULE = 'REMOVE_SELECTED_SCHEDULE';
export const SET_CURRENT_SCHEDULE = 'SET_CURRENT_SCHEDULE';
export const REMOVE_CURRENT_SCHEDULE = 'REMOVE_CURRENT_SCHEDULE';
export const SET_FILTER_REPLACEMENT_DATE = 'SET_FILTER_REPLACEMENT_DATE';
export const REMOVE_FILTER_REPLACEMENT_DATE = 'REMOVE_FILTER_REPLACEMENT_DATE';
export const SET_DEVICE_REBOOT_DATE = 'SET_DEVICE_REBOOT_DATE';
export const REMOVE_DEVICE_REBOOT_DATE = 'REMOVE_DEVICE_REBOOT_DATE';
export const SET_FIRMWARE_DATA = 'SET_FIRMWARE_DATA';
export const REMOVE_FIRMWARE_DATA = 'REMOVE_FIRMWARE_DATA';
export const IS_APPLY_CLICKED = 'IS_APPLY_CLICKED';
export const REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS';
export const CHANGE_FORCE_FILTER_COMMAND_MODAL = 'CHANGE_FORCE_FILTER_COMMAND_MODAL';
